import * as b from "react";
const H = /*#__PURE__*/ b.createContext({
    values: {},
    setValue: ()=>{},
    rawValues: {},
    setRawValue: ()=>{},
    formStatus: "filling",
    register: ()=>{},
    formErrors: {},
    setFormError: ()=>{},
    jumpToNext: ()=>{},
    submit: ()=>{},
    validate: ()=>({}),
    formId: ""
}), y = ()=>b.useContext(H), J = (param)=>{
    let { name: r , value: s , defaultValue: o , onChange: i , disabled: u  } = param;
    var f;
    const { setRawValue: p , setValue: E , rawValues: e , setFormError: x , register: c , formStatus: F  } = y();
    return b.useEffect(()=>{
        var t;
        if (e[r] === void 0) {
            const w = (t = s != null ? s : o) != null ? t : !1;
            E({
                name: r,
                value: w
            }), p({
                name: r,
                value: w
            });
        }
    }, [
        s,
        r,
        o,
        e,
        E,
        p
    ]), {
        name: r,
        value: s,
        defaultValue: o != null ? o : s === void 0 ? (f = e[r]) != null ? f : !1 : void 0,
        focusableRef: (t)=>c(r, {
                focusableElement: t
            }),
        onChange: (t)=>{
            p({
                name: r,
                value: t
            }), E({
                name: r,
                value: t
            }), x({
                name: r,
                error: ""
            }), i == null || i(t);
        },
        disabled: F === "sending" || u
    };
}, K = (param)=>{
    let { name: r , value: s , defaultValue: o , processValue: i , helperText: u , optional: p , error: E , disabled: e , onBlur: x , validate: c , onChange: F , onChangeValue: f  } = param;
    var q, I, N;
    const { setRawValue: t , setValue: w , rawValues: S , values: z , formErrors: P , formStatus: A , setFormError: j , register: D  } = y(), T = (I = (q = s != null ? s : o) != null ? q : S[r]) != null ? I : "", G = b.useRef(i);
    return b.useEffect(()=>{
        t({
            name: r,
            value: T
        }), w({
            name: r,
            value: G.current(T)
        });
    }, [
        r,
        T,
        t,
        w
    ]), {
        value: s,
        defaultValue: o != null ? o : s === void 0 ? (N = S[r]) != null ? N : "" : void 0,
        name: r,
        helperText: P[r] || u,
        required: !p,
        error: E || !!P[r],
        disabled: e || A === "sending",
        onBlur: (R)=>{
            j({
                name: r,
                error: c == null ? void 0 : c(z[r], S[r])
            }), x == null || x(R);
        },
        inputRef: (R)=>D(r, {
                input: R,
                validator: c
            }),
        onChange: (R)=>{
            const d = R.currentTarget.value, k = i(d);
            t({
                name: r,
                value: d
            }), w({
                name: r,
                value: k
            }), j({
                name: r,
                error: ""
            }), F == null || F(R), f == null || f(k, d);
        }
    };
};
export { H as FormContext, J as useControlProps, K as useFieldProps, y as useForm };
